import React, { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import xdk from '@accedo/xdk-core';

import { getModalData } from '#/redux/modules/modal/selectors';
import styles from './parentZoneModalTV.scss';

import {
  loadChildrenPrivacyPolicy,
  requestPrivacyPolicy,
  requestHelp,
  loadTermsOfService,
} from '#/redux/modules/accedoOne/actions';

const ParentZoneModalTV = () => {
  const data = useSelector(state => getModalData(state));
  const dispatch = useDispatch();
  const contentAreaRef = useRef(null);

  const getModalContent = useCallback(() => {
    return useSelector(state => data?.selector(state));
  }, [data]);

  useEffect(() => {
    const onSystemKeydown = ({ id }) => {
      const scrollStep = contentAreaRef.current.clientHeight / 2;
      switch (id) {
        case 'device:vkey:down':
          contentAreaRef.current.scrollBy(0, scrollStep);
          break;
        case 'device:vkey:up':
          contentAreaRef.current.scrollBy(0, -scrollStep);
          break;
        default:
          break;
      }
    };

    xdk.environment.addEventListener(
      xdk.environment.SYSTEM.KEYDOWN,
      onSystemKeydown,
    );
    dispatch(loadChildrenPrivacyPolicy);
    dispatch(requestPrivacyPolicy);
    dispatch(loadTermsOfService);
    dispatch(requestHelp);
    contentAreaRef?.current?.focus();

    return () => {
      xdk.environment.removeEventListener(
        xdk.environment.SYSTEM.KEYDOWN,
        onSystemKeydown,
      );
    };
  }, []);

  return (
    <>
      <h3 className={styles.title}>{data?.title}</h3>
      <p ref={contentAreaRef} tabIndex={0} className={styles.modalText}>
        {getModalContent()}
      </p>
    </>
  );
};

export default ParentZoneModalTV;
